<template>
  <div class="Dashboard">
    <Dashboard msg="Jaja hier ein Text"/>
  </div>
</template>

<script>
// @ is an alias to /src
import Dashboard from '@/components/Dashboards/Dashboard.vue'

export default {
  name: 'dashboard',
  components: {
    Dashboard
  }
}
</script>
